import { render, staticRenderFns } from "./StatementsToggle.vue?vue&type=template&id=0be25c7c&"
import script from "./StatementsToggle.vue?vue&type=script&lang=js&"
export * from "./StatementsToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports